'use client'

import React from 'react'
import { Eyebrow } from '@/components/Eyebrow'
import { CMSLink, type CMSLinkType } from '@/components/Link'
import { EyebrowType } from '@/fields/eyebrow'
import { Heading } from '@/components/ui/heading'
import { cn } from '@/utilities/ui'
import { Text } from '@/components/ui/text'
import RichText from '@/components/RichText'

export function Callout({
  eyebrow,
  link,
  heading,
  headingClassName,
  body,
  content,
  variant = 'dark',
  children,
  className,
}: {
  variant: 'dark' | 'light'
  eyebrow?: EyebrowType
  link?: CMSLinkType
  heading?: string
  headingClassName?: string
  body?: string
  className?: string
  children?: React.ReactNode
  content?:
    | {
        [k: string]: unknown
        root: {
          type: string
          children: {
            type: string
            version: number
            [k: string]: unknown
          }[]
          direction: ('ltr' | 'rtl') | null
          format: 'left' | 'start' | 'center' | 'right' | 'end' | 'justify' | ''
          indent: number
          version: number
        }
      }
    | null
    | undefined
}) {
  return (
    <div className={cn(variant === 'dark' ? 'text-dark' : 'text-light', className)}>
      {eyebrow && (
        <Eyebrow
          variant={variant}
          label={eyebrow.label}
          color={eyebrow.color}
          className="mb-[50px]"
        />
      )}
      {heading && (
        <Heading size="h2" className={headingClassName}>
          {heading}
        </Heading>
      )}
      {body && (
        <div className="mt-[30px]">
          <Text size="lg">{body}</Text>
        </div>
      )}
      {content && (
        <RichText
          className={cn('mt-[30px]', variant === 'dark' ? 'prose-dark' : 'prose-light')}
          data={content}
        />
      )}
      {children}
      <div className="mt-[60px]">{link && <CMSLink {...link} />}</div>
    </div>
  )
}
